import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';

export default function EarningsCallConversationThreads({conversation_threads} :any) {
  const columns = [
    { field: 'id', headerName: 'Conversations', width: 300, renderCell: (params) => (<a target="_blank" rel="noopener noreferrer" href={params.getValue(params.id, 'path') }><strong>{params.value}</strong></a>)},
  ];

  const rows = conversation_threads;

  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
        <p><strong>AI Assistant Conversation Threads</strong></p>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            autoHeight={true}
            autoPageSize={true}
            density={"compact"}
            disableColumnMenu
          />
      </p>
    </div>
  );
}
